export const SET_THEME = 'APP_CONFIG__SET_THEME';
export const SET_BACK_BUTTON = 'APP_CONFIG__SET_BACK_BUTTON';
export const SET_DEVICE = 'SET_DEVICE';

export type SetBackButtonType = typeof SET_BACK_BUTTON;
export type SetDevice = typeof SET_DEVICE;
